// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"e2eb2de4","2008":"9dcd38f8","5531":"9dcd38f8"}[chunkId] + ".chunk.css";
};